/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/close/close_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ CLOSE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Close extends Component {
	handleClick = (e) => {
        this.props.handleClick(e);
	}
	render() {
	    return(
	        <div className={`${sheet.classes.close} close`} onClick={this.handleClick}><div className={`icon`}>+</div></div>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Close;
